import React, {Fragment, useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import Crop from 'react-image-crop'
import styled from 'styled-components'
import 'react-image-crop/dist/ReactCrop.css'
import { FaCrop } from 'react-icons/fa'
import { FrameMenu, Crop as CropMenu } from '../../containers/FrameMenu'

const CropImage = ({ allowToCrop, aspect, crop, src, onChange }) => {
    const [state, setState] = React.useState(crop)
  const debounceRef = useRef(null)
  const onclick = () => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current)
    }
    onChange(state)
  }

  useEffect(() => {
    setState(crop);
  }, [crop]);

  useEffect(() => {
    if (!allowToCrop) return

    if (debounceRef.current) {
      clearTimeout(debounceRef.current)
    }

    debounceRef.current = setTimeout(() => {
      onChange(state)
    }, 500)

    return () => clearTimeout(debounceRef.current)
  }, [state, allowToCrop, onChange])



  return (<Fragment>
    {allowToCrop && (
      <Overlay>
        <Background>
          <Crop src={src} onChange={setState} crop={{ ...state, aspect: aspect }} />
        </Background>
        <FrameMenu show={true} isSidebarOpen={true}>
          <CropMenu onClick={onclick} icon={FaCrop}>Skończ kadrowanie</CropMenu>
        </FrameMenu>
      </Overlay>
    )}
  </Fragment>)
}

CropImage.propTypes = {
  allowToCrop: PropTypes.bool.isRequired,
  aspect: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
  crop: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }).isRequired,
  src: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  typeOf: PropTypes.oneOf([false, 'picture', 'background']),
}

export default CropImage

const Overlay = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 100vw;
  max-height: 100vh;
  top: 0;
  left: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.8);
  display: block;
  overflow: hidden;
`

const Background = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 100vw;
  max-height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    position: relative;
    max-width: 100vw;
    max-height: 100vh;
  }
`



// WEBPACK FOOTER //
// ./src/components/CropImage/index.js